"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.payformFilterState = exports.roomTypeFilterState = exports.categoryFilterState = void 0;
const recoil_1 = require("recoil");
const getInitialCategoryFilter = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise(resolve => {
        const rootDiv = document.getElementById('root');
        const dataset = rootDiv === null || rootDiv === void 0 ? void 0 : rootDiv.dataset.initData;
        const hasDataset = dataset !== undefined && dataset !== '{}' && dataset !== '';
        if (hasDataset) {
            const parsedData = JSON.parse(dataset);
            const categoryValue = parsedData.last_category;
            if (!!categoryValue) {
                const splitted = categoryValue.split(',');
                resolve({ id: splitted[0] || '', name: splitted[1] || '' });
            }
            else
                resolve({ id: '', name: '' });
        }
        else
            resolve({ id: '', name: '' });
    });
});
exports.categoryFilterState = (0, recoil_1.atom)({
    key: 'categoryFilterState',
    default: getInitialCategoryFilter().then(res => res),
});
// ?                     인기or최신or나의 최신 |   찜   |      조회      |  수요조사  |    커미션
exports.roomTypeFilterState = (0, recoil_1.atom)({
    key: 'roomTypeFilterState',
    default: '',
});
exports.payformFilterState = (0, recoil_1.atom)({
    key: 'payformFilterState',
    default: false,
});
